import React from 'react';
import { Box, Button, Flex, Heading, SimpleGrid, Text } from '@thebouqs/ui';
import { DotwRedesignBoxProps } from './DotwRedesignBox.d';
import useTranslation from '@/hooks/useTranslation';
import { DotwRedesignStyles } from './DotwRedesign.styles';

const DotwRedesignBox = ({
  data,
  dynamicDotwStrings,
  hasDiscount,
  onCheckoutClick,
}: DotwRedesignBoxProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Box className="dotw-dialog-redesign" sx={DotwRedesignStyles}>
      <Box
        className="dotw-dialog-redesign__content"
        paddingLeft={['auto', '0.5rem']}
        paddingRight={['1.5rem', '0px']}>
        <Heading as="h2" className="dotw-dialog-redesign__heading text-center">
          {dynamicDotwStrings.heading}
          {hasDiscount && (
            <>
              {' '}
              <span className="dotw-dialog-redesign__discount-text-title">
                ({data.discount} OFF)
              </span>
            </>
          )}
        </Heading>
        <Text
          className="dotw-dialog-redesign__description-subtitle text-center"
          maxWidth={['100%', '590px']}
          overflow={['visible', 'hidden']}
          textOverflow={['unset', 'ellipsis']}
          whiteSpace={['normal', 'nowrap']}
          margin={['0', '0 auto']}>
          {dynamicDotwStrings.description}
        </Text>
        <SimpleGrid columns={{ sm: 1, lg: 2 }} spacing="4" marginTop="28px">
          <Flex
            className="dotw-dialog-redesign-product__image-container"
            justifyContent="center">
            <img
              src={data.imageUrl}
              alt={data.imageAlt}
              width="285px"
              height="285px"
              loading="lazy"
            />
          </Flex>
          <Flex
            className="dotw-dialog-redesign-product__details"
            flexDirection="column">
            <Flex
              className="dotw-product__price-details"
              justifyContent="space-between">
              <Text
                fontWeight="600"
                size="sm"
                textTransform="uppercase"
                fontSize="24px"
                color="#144B3C"
                className="dotw-product__discount">
                {dynamicDotwStrings.tag}
              </Text>
              <Box>
                <Text
                  as="span"
                  mr="2"
                  color="darkerGray"
                  size="sm"
                  fontSize="24px"
                  fontWeight="400"
                  textDecorationLine="line-through"
                  className="dotw-product__price--striked">
                  ${Math.ceil(data.price as number)}
                </Text>
                <Text
                  as="span"
                  color={hasDiscount ? 'primary' : null}
                  size="sm"
                  fontSize="24px"
                  fontWeight="600"
                  className="dotw-product__price">
                  ${Math.ceil(data.discountedPrice as number)}
                </Text>
              </Box>
            </Flex>
            <Box>
              <Flex
                className="dotw-dialog-redesign-product__description"
                marginBottom="3px">
                <Text
                  as="span"
                  mr="2"
                  size="sm"
                  fontSize="24px"
                  fontWeight="400"
                  className="dotw-dialog-redesign__description">
                  BOUQ:
                </Text>
                <Text
                  as="span"
                  mr="2"
                  size="sm"
                  fontSize="24px"
                  fontWeight="400"
                  className="dotw-dialog-redesign__description-subtitle">
                  {data.name}
                </Text>
              </Flex>
              <Flex
                className="dotw-dialog-redesign-product__description"
                marginBottom="3px">
                <Text
                  as="span"
                  mr="2"
                  size="sm"
                  fontSize="16px"
                  fontWeight="400"
                  fontStyle="italic"
                  textAlign="left"
                  maxWidth="290px"
                  dangerouslySetInnerHTML={{ __html: data.description }}></Text>
              </Flex>
              <Flex
                className="dotw-dialog-redesign-product__description"
                marginBottom="3px">
                <Text
                  as="span"
                  mr="2"
                  size="sm"
                  fontSize="24px"
                  fontWeight="400"
                  className="dotw-dialog-redesign__description">
                  SIZE:
                </Text>
                <Text
                  as="span"
                  mr="2"
                  size="sm"
                  fontSize="24px"
                  fontWeight="400"
                  className="dotw-dialog-redesign__description-subtitle">
                  {data.size}
                </Text>
              </Flex>
              <Flex className="dotw-dialog-redesign-product__description">
                <Text
                  as="span"
                  mr="2"
                  size="sm"
                  fontSize="24px"
                  fontWeight="400"
                  className="dotw-dialog-redesign__description">
                  DELIVERY:
                </Text>
                <Text
                  as="span"
                  mr="2"
                  size="sm"
                  fontSize="24px"
                  fontWeight="400"
                  className="dotw-dialog-redesign__description-subtitle">
                  {data.delivery}
                </Text>
              </Flex>
            </Box>

            {data.active && (
              <Button
                variant="solid"
                colorScheme="green"
                width="100%"
                marginTop="1rem"
                className="dotw-dialog-redesign__cta button button--full-width"
                as="a"
                href={data.url}
                onClick={onCheckoutClick}>
                {t('common.checkout')}
              </Button>
            )}
            <Text
              as="span"
              mr="2"
              size="sm"
              fontSize="14px"
              fontWeight="400"
              textAlign={['center', 'left']}>
              {t('dotw.notCombinable')}
            </Text>
          </Flex>
        </SimpleGrid>
      </Box>
    </Box>
  );
};

export default DotwRedesignBox;
